import React from "react";
import SupplyDemandAnalysis from "./SupplyDemandAnalysis";

const supplyDemandAnalysis = {
  path: "supply-demand",
  sideNav: {
    group: 4,
    order: 72,
    label: "Supply vs Demand",
    entityType: "all",
    allowedRole: ["admin", "supply_analyst"],
    auth: ["authenticated"],
  },
  route: {
    index: {
      element: <SupplyDemandAnalysis />,
      allowedRole: ["admin", "supply_analyst"],
      entityType: "all",
      auth: ["authenticated"],
    },
  },
};

export default supplyDemandAnalysis;
